/**
 * Departments Service (Web)
 * 
 * Chức năng: Service để gọi API liên quan đến phòng ban cho web app
 * Dùng để: 
 * - CRUD operations cho departments
 * - Tích hợp với WebApiService
 */
import { DepartmentsService } from '@shared/services/departments.service';
import { API_URL } from '../config/constants';
import { STORAGE_KEYS } from '@shared/constants';

class WebDepartmentsService extends DepartmentsService {
  protected getBaseURL(): string {
    return API_URL;
  }

  protected async getAuthToken(): Promise<string | null> {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  }

  protected async handleUnauthorized(_message?: string): Promise<void> {
    // Clear token and redirect to login
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    window.location.href = '/login';
  }
}

export const departmentsService = new WebDepartmentsService();

